import { useRegularClassScheduleQuery } from "src/services/react-query-apis/get-regular-class-schedules";
import { Select } from "src/components/common/form/select";
import { getJpWeekDay } from "src/utils/formatdate";
import { useFormContext } from "react-hook-form";
import moment from "moment";

export const RegularClassScheduleSelect = () => {
  const { formState, register, watch } = useFormContext();

  const regularClassScheduleQuery = useRegularClassScheduleQuery({
    id: watch("regular_class_id"),
    day_week: getJpWeekDay(watch("attendance_date")),
    rank: watch("regular_class_id") === 1 ? 1 : null,
    withInvalidated: 1,
    month: moment(watch("attendance_date")).format("YYYY-MM"),
    queryConfig: {
      enabled: !!(watch("regular_class_id") && watch("attendance_date")),
    },
  });

  let scheduleOptions = [{ value: 0, label: "選択してください" }];

  regularClassScheduleQuery.data?.data?.forEach(schedule => {
    scheduleOptions.push({
      value: schedule.id,
      label: `${schedule.start_time} - ${schedule.end_time} ${schedule?.class_level?.in_text ? `(${schedule?.class_level?.in_text})` : ""}`,
    });
  });

  return (
    <Select
      label="クラス"
      options={scheduleOptions}
      name="regular_class_schedule_id"
      error={formState.errors["regular_class_schedule_id"]}
      registration={register("regular_class_schedule_id")}
      readOnly={!watch("attendance_date")}
    />
  );
};
